import { ChainId } from '@taraswap/sdk-core'

/** Chains supported by the AssetActivity subscription service */
export const SUBSCRIPTION_CHAINIDS = [
  ChainId.MAINNET,
  ChainId.ARBITRUM_ONE,
  ChainId.BNB,
  ChainId.OPTIMISM,
  ChainId.POLYGON,
  ChainId.CELO,
]
